import { FC } from "react";
import { IconPropsType } from ".";

export const RotateRight: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.53957 13.9942V12.1275C4.95228 11.9872 3.5206 11.1145 2.66622 9.76648C1.81167 8.41836 1.63207 6.74857 2.17985 5.24898C2.72779 3.74948 3.94087 2.59078 5.46173 2.1144C6.98275 1.63798 8.63822 1.89826 9.94048 2.81848C11.2429 3.73857 12.0439 5.21382 12.1074 6.80953C12.1708 8.40523 11.4896 9.93973 10.2645 10.9609V8.41061H8.40208V13.0773C8.40208 13.3247 8.50017 13.5622 8.67475 13.7371C8.84949 13.9122 9.08626 14.0105 9.33328 14.0105H13.9896V12.1438H11.7405C12.92 11.0488 13.6862 9.57921 13.9101 7.9835C14.1339 6.3878 13.8017 4.76363 12.9692 3.38517C12.1369 2.00642 10.8554 0.957922 9.34105 0.416255C7.82685 -0.125245 6.1725 -0.126536 4.65734 0.412349C3.14218 0.951432 1.85892 1.99797 1.02416 3.37506C0.189604 4.75235 -0.145439 6.37602 0.0757753 7.97214C0.296961 9.56835 1.0607 11.039 2.23828 12.1361C3.41599 13.2332 4.93505 13.8896 6.53951 13.9945L6.53957 13.9942Z"
        fill={props.color}
      />
    </svg>
  );
};
